import React, { Component } from "react";
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Form } from "react-redux-form";
import Article from "../article/article.component";
import ComponentArticle from "../component/index";
import FormulaComponent from "../formula/formula.component";

import { Selected_Index, ARTICLE_COMPONENT_HEADER } from "../../../../../../../constants/external-constants";
import { articleCatalogueMilestoneActions } from "../../../../../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer";
import { NoSubscription } from "../../../../../dashboard/no-subscription/no-subscription.component";

class ArticleDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.props.getArticleCatalogueMilestoneDetails(this.props.articleId)
            .then( async (res) => {
                const { getSelectedCountryCode, getCountryCodeList, getSalesOrganizationList, getSelectedSalesOrg } =  this.props;

                let selectedCountry = "";
                let selectSalesOrg = "";
                
                if(res?.CountryID){
                  selectedCountry = await getSelectedCountryCode(res?.CountryID)
                }

                if(res?.SalesOrganizationID){
                  selectSalesOrg = await getSelectedSalesOrg(res?.SalesOrganizationID)
                }

                getCountryCodeList(1, selectedCountry ).then(() =>{
                    getSalesOrganizationList(1, selectSalesOrg).then(() => {
                        this.setState({isLoading: false});
                    })
                });

                

        });
        this.fetchComponentData(this.props.articleComponent.length > 0 ? this.props.articleComponent : []);
       
    }

    componentWillUnmount() {
        this.props.resetArticleCatalogueMilestoneForm();
    }

    fetchComponentData = (value) => {
        this.props.FormChange("articleCatalogueMilestoneForm.articleComponent", value ?? []);
    };

    render() {
        const {
            activeTabIcon,
            articleId,
            onDisabledTab,
            onDisableButton,
            articleCatalogueMilestoneForm,
            articleComponent,
            isArticleAlreadyExist,
            isReadOnly,
            isReadAndExtractOnly,
            isReadAndWrite
        } = this.props;

        const updateDisabledTab = (index) => {
            if (onDisabledTab) {
                onDisabledTab(index);
            }
        };

        const updateDisabledButton = (index, another) => {
            if (onDisableButton) {
                onDisableButton(index, another);
            }
        };

        return (
            <>
                <Form method="post" role="form" model="articleCatalogueMilestoneForm">
                    <div className="details-moda-form__component">
                        {parseInt(activeTabIcon) === parseInt(Selected_Index.i_Zero) && (
                            this.state.isLoading? <NoSubscription/> :
                            <Article
                                articleId={articleId}
                                updateDisabledTab={updateDisabledTab}
                                updateDisabledButton={updateDisabledButton}
                                alternateLogic={articleCatalogueMilestoneForm.isAlternateLogic || false}
                                isArticleAlreadyExist={isArticleAlreadyExist}
                                isViewing={this.props.isViewing}
                            />
                        )}
                        {parseInt(activeTabIcon) === parseInt(Selected_Index.i_One) && (
                            <ComponentArticle
                                articleId={articleId}
                                dataComponent={articleCatalogueMilestoneForm.articleComponent.length > 0 ? articleCatalogueMilestoneForm.articleComponent : (articleComponent.length > 0 ? articleComponent : [])}
                                header={ARTICLE_COMPONENT_HEADER}
                                fetchComponentData={this.fetchComponentData}
                                isReadAndWrite={isReadAndWrite}
                                updateDisabledButton={updateDisabledButton}
                                isViewing={this.props.isViewing}
                            />
                        )}
                        {parseInt(activeTabIcon) === parseInt(Selected_Index.i_Two) && (
                            <FormulaComponent
                                articleId={articleId}
                                fetchComponentData={this.fetchComponentData}
                                isReadAndWrite={true}
                                updateDisabledButton={updateDisabledButton}
                                componentsMilestone={articleCatalogueMilestoneForm.articleComponent}
                                isViewing={this.props.isViewing}
                            />
                        )}
                    </div>
                </Form>
            </>
        );
    }
}

export default withRouter(connect(
    state => {
        const {
            articleCatalogueMilestone
            , translation
            , form: { forms: { articleCatalogueMilestoneForm: { $form } } }
        } = state;
        const { articleCatalogueMilestoneForm } = state.form;
        return {
            translation
            , articleCatalogueMilestone
            , articleCatalogueMilestoneForm
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, articleCatalogueMilestoneActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ArticleDetails));